import React from "react";
import { Link } from "react-router-dom";
import { PRODUCT_IMAGES } from "@/data/products";

const SHOWCASE = [
  {
    title: "Caneca de Cerâmica",
    subtitle: "Transfer Digital",
    src: PRODUCT_IMAGES.canecaPersonalizada,
    link: "/produtos/caneca-personalizada",
  },
  {
    title: "Caneca Preta Matte",
    subtitle: "Transfer Digital",
    src: PRODUCT_IMAGES.canecaPreta,
    link: "/produtos/caneca-personalizada",
  },
  {
    title: "Caneca Azul Royal",
    subtitle: "Transfer Digital",
    src: PRODUCT_IMAGES.canecaAzul,
    link: "/produtos/caneca-personalizada",
  },
  {
    title: "Caneca Vermelha",
    subtitle: "Transfer Digital",
    src: PRODUCT_IMAGES.canecaVermelha,
    link: "/produtos/caneca-personalizada",
  },
  {
    title: "Moletom com DTF Têxtil",
    subtitle: "DTF Full Color",
    src: PRODUCT_IMAGES.dtfMoletom,
    link: "/produtos/dtf-textil",
  },
  {
    title: "Sacola de Algodão",
    subtitle: "DTF Full Color",
    src: PRODUCT_IMAGES.dtfSacola,
    link: "/produtos/dtf-textil",
  },
  {
    title: "Camiseta com Transfer",
    subtitle: "Transfer Digital",
    src: PRODUCT_IMAGES.transferCamiseta,
    link: "/produtos/transfer-digital",
  },
];


const BrandShowcase = ({ onQuoteClick }) => {
  return (
    <section
      id="marca-aparece"
      data-testid="brand-showcase-section"
      className="py-24 lg:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <span
            className="inline-block text-[0.72rem] font-semibold uppercase tracking-[0.28em] text-[var(--mn-gold)] mb-4"
            data-testid="brand-showcase-eyebrow"
          >
            Como sua marca aparece
          </span>
          <h2 className="font-serif-display font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.1] mb-6 text-[var(--mn-black)]">
            Sua marca aplicada com
            <br />
            <span className="italic text-[var(--mn-gold)]">acabamento profissional</span>
          </h2>
          <p className="text-[var(--mn-dark)] text-sm md:text-base leading-relaxed">
            Veja como o logotipo da sua empresa fica em nossos brindes — impressão nítida, cores fiéis e centralização perfeita em cada peça. Do primeiro protótipo à entrega do lote completo, cuidamos de cada detalhe.
          </p>
        </div>

        <div
          data-testid="brand-showcase-grid"
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8"
        >
          {SHOWCASE.map((item) => (
            <Link
              key={item.title + item.src}
              to={item.link}
              data-testid={`showcase-item-${item.title.toLowerCase().replace(/\s+/g, "-").replace(/[áàâã]/g, "a").replace(/[éê]/g, "e").replace(/[íî]/g, "i").replace(/[óô]/g, "o").replace(/[úû]/g, "u").replace(/ç/g, "c")}`}
              className="group block"
            >
              <div className="relative aspect-square overflow-hidden rounded-lg bg-[#F5F5F5] border border-[var(--mn-black)]/[0.08] transition-all duration-500 hover:border-[var(--mn-gold)]/40 hover:shadow-[0_8px_32px_-8px_rgba(153,101,21,0.25)]">
                <img
                  src={item.src}
                  alt={`${item.title} com logo M NAIEF`}
                  className="w-full h-full object-contain p-6 transition-transform duration-700 ease-out group-hover:scale-105"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="mt-4 space-y-1">
                <div className="text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-[var(--mn-gold)]">
                  {item.subtitle}
                </div>
                <div className="font-serif-display font-bold text-base md:text-lg text-[var(--mn-black)] leading-tight group-hover:text-[var(--mn-gold)] transition-colors">
                  {item.title}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-[var(--mn-black)]/10 pt-10">
          <p className="text-sm text-[var(--mn-dark)] max-w-xl leading-relaxed">
            <strong className="font-semibold text-[var(--mn-black)]">Quer ver seu logo aqui?</strong> Envie sua arte e produzimos um mock-up gratuito antes da produção — sem compromisso.
          </p>
          <button
            type="button"
            onClick={onQuoteClick}
            data-testid="brand-showcase-cta"
            className="btn-mn-primary !py-4 !px-8 whitespace-nowrap"
          >
            <i className="fa-regular fa-paper-plane" />
            Solicitar meu mock-up
          </button>
        </div>
      </div>
    </section>
  );
};

export default BrandShowcase;
